import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import apiClient from "./utils/axios";
import { AUTH } from "./config/api";
import toast from "react-hot-toast";

function Login() {
  const [formdata, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [isCustomer, setIsCustomer] = useState(false);
  const [tableId, setTableId] = useState(null);

  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const id = params.get("tableId");
    if (id) {
      setTableId(id);
      setIsCustomer(true); // ✅ auto switch to customer mode if opened from QR
    }
  }, [location]);

  const validate = () => {
    const e = {};
    if (!formdata.email || !/^\S+@\S+\.\S+$/.test(formdata.email))
      e.email = "Valid email required";

    if (isCustomer) {
      if (!formdata.name || formdata.name.length < 2)
        e.name = "Name must be at least 2 characters";
    } else {
      if (!formdata.password || formdata.password.length < 4)
        e.password = "Password must be 4+ characters";
    }

    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const formChangeData = (ev) => {
    const { name, value } = ev.target;
    setForm((f) => ({ ...f, [name]: value }));
    setMessage("");
  };

  const handleSubmit = async (ev) => {
    ev.preventDefault();
    if (!validate()) return;
    setLoading(true);
    setMessage("");

    try {
      const payload = isCustomer ? { ...formdata, tableId } : formdata;

      const { data } = await apiClient.post(AUTH.LOGIN, payload);

      // ✅ store user info
      localStorage.setItem("token", data.jwtToken);
      localStorage.setItem("role", data.role);
      localStorage.setItem("email", data.email);

      // ✅ if customer login via QR
      if (tableId) {
        localStorage.setItem("tableId", tableId);
        localStorage.setItem("customerName", formdata.name);
        toast.success("Customer logged in for table " + tableId);
        window.location.href = "/";
        return;
      }

      // ✅ staff/admin redirect
      if (data.role === "admin") {
        window.location.href = "/index";
      } else if (data.role === "manager") {
        window.location.href = "/dashboard";
      } else {
        window.location.href = "/";
      }
    } catch (err) {
      toast.error(err.response?.data?.message || err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-scroller">
      <div className="container-fluid page-body-wrapper full-page-wrapper">
        <div className="row w-100 m-0">
          <div className="content-wrapper full-page-wrapper d-flex align-items-center auth login-bg">
            <div className="card col-lg-4 mx-auto">
              <div className="card-body px-5 py-5">
                <h3 className="card-title text-left mb-3">Login</h3>
                <p>{message}</p>

                <form method="post" onSubmit={handleSubmit}>
                  {isCustomer && (
                    <div className="form-group">
                      <label>Name *</label>
                      <input
                        type="text"
                        name="name"
                        value={formdata.name || ""}
                        onChange={formChangeData}
                        className="form-control p_input"
                      />
                      {errors.name && (
                        <p className="text-danger">{errors.name}</p>
                      )}
                    </div>
                  )}

                  <div className="form-group">
                    <label>Email *</label>
                    <input
                      type="text"
                      name="email"
                      value={formdata.email || ""}
                      onChange={formChangeData}
                      className="form-control p_input"
                    />
                    {errors.email && (
                      <p className="text-danger">{errors.email}</p>
                    )}
                  </div>

                  {!isCustomer && (
                    <div className="form-group">
                      <label>Password *</label>
                      <input
                        type="password"
                        name="password"
                        value={formdata.password || ""}
                        onChange={formChangeData}
                        className="form-control p_input"
                      />
                      {errors.password && (
                        <p className="text-danger">{errors.password}</p>
                      )}
                    </div>
                  )}

                  <div className="text-center">
                    <button
                      type="submit"
                      className="btn btn-primary btn-block enter-btn"
                      disabled={loading}
                    >
                      {loading ? "Please wait..." : "Login"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          {/* content-wrapper ends */}
        </div>
      </div>
    </div>
  );
}

export default Login;
